import React from "react";
import { useVSU } from "../store";

// Легенда экрана (5.10). Четыре пояснения из клиентского словаря.
// Формулировка lgTerm приводится дословно и разработчиком не переписывается.
export default function Legend() {
  const { t } = useVSU();
  return (
    <div className="vsu-legend">
      <span className="vsu-lg">{t("lgPie")}</span>
      <span className="vsu-lg vsu-qnote">{t("lgDash")}</span>
      <span className="vsu-lg vsu-qnote">{t("lgTerm")}</span>
      <span className="vsu-lg vsu-qnote">{t("lgClick")}</span>
    </div>
  );
}
